/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import { ReactNode } from 'react';
import styles from '../../styles/components/common/AuthLayout.module.css';

interface Props {
	left: ReactNode;
	right: ReactNode;
}

const AuthLayout = ({ left, right }: Props) => {
	return (
		<div className={styles.container}>
			<div className={styles.left}>{left}</div>
			<div className={styles.right}>{right}</div>
		</div>
	);
};

export default AuthLayout;
